import { useLocalObservable } from 'mobx-react-lite';

import { PermissionsRequestStatuses } from '@gem/call/Model/callPermissions/callPermissionsModel.types';
import { PERMISSIONS_REQUEST_TYPES } from '@gem/call/constants';

import { IRequestsPermissionsBlockProps } from './RequestsPermissionsBlock.types';

interface IRequestsPermissionsBlockPresenter {
  permissionsRequests: string[] | null;
  approveAll(): void;
}

export const useRequestsPermissionsBlockPresenter = (
  props: IRequestsPermissionsBlockProps
): IRequestsPermissionsBlockPresenter => {
  const presenter = useLocalObservable<IRequestsPermissionsBlockPresenter>(() => ({
    get permissionsRequests(): string[] | null {
      return props.call.permissionsRequests.get(props.permissionType) || null;
    },

    approveAll(): void {
      if (presenter.permissionsRequests?.length) {
        presenter.permissionsRequests?.forEach((userId: string) => {
          if (props.call.channelId) {
            props.callController.updatePermissionRequestForUser({
              channelId: props.call.channelId,
              access: PERMISSIONS_REQUEST_TYPES[props.permissionType],
              status: PermissionsRequestStatuses.Approved,
              userId: userId,
            });
          }
        });
      }
    },
  }));

  return presenter;
};
